import { Link, useLocation } from 'react-router-dom'

/**
 * In-app 404 — rendered inside the shell for any route that doesn't exist, instead of
 * silently bouncing to /opportunities (which would make a mistyped link look like a
 * redirect bug).
 */
export function NotFound() {
  const { pathname } = useLocation()

  return (
    <div className="view active">
      <div className="empty">
        <div className="empty-icon">🧭</div>
        <h1 className="empty-title">This page doesn&rsquo;t exist</h1>
        <div className="empty-sub" style={{ marginBottom: 20 }}>
          Nothing lives at <code>{pathname}</code>. The link may be out of date, or the address mistyped.
        </div>
        <Link to="/opportunities" className="btn-outline">
          ← Back to opportunities
        </Link>
      </div>
    </div>
  )
}
